// import SwiperComponent from '../../views/swiper/base/swiper'
import MainHamburgerComponent from '../../views/hamburger/hamburger'
import HamburgerComponent from '../../views/hamburger-mobile/hamburger'
import AccordianComponent from '../../views/accordian/base/accordian'
import MapboxComponent from '../../views/mapbox/mapbox'
import PhotoswipeComponent from '../../views/loop/project'
import MainMenuComponent from '../../views/main-menu/main-menu'
import FormComponent from '../../views/form/base/form'
import HomeComponent from '../../views/home/home'
import ImageSwiperComponent from '../../views/image-swiper/base/swiper'

const components = {
  ImageSwiperComponent,
  HamburgerComponent,
  AccordianComponent, 
  MapboxComponent,
  PhotoswipeComponent,
  MainMenuComponent,
  HomeComponent,
  FormComponent,
  MainHamburgerComponent
}

export default components;